<!-- 设备管理-设备列表页面 -->
<template>
  <div class="gas-page">
    <!--主页面 -->
    <div class="flex-row" style="height: 100%">
      <!-- 左侧树 -->
      <div class="section-mian_left tree-line-style">
        <div class="left_title">设备信息</div>
        <div class="device-tab">
          <div
            v-for="item in calType.column"
            :key="item.typeId"
            :class="['tab', type.prop == item.prop ? 'active' : '']"
            @click="handleChange(item)"
          >
            {{ item.label }}
          </div>
        </div>
        <!-- <ioc-tab-group :option="calType"
                       @change="handleChange"></ioc-tab-group> -->
        <div v-if="type.prop === 'tab1'" class="left-type_area">
          <ele-group-tree
            @getCode="handleClickDeviceGroup"
            @sendData="getGasTreeData"
            :paramsType="paramsType"
            @refresh="initGet()"
          ></ele-group-tree>
        </div>
        <div v-show="type.prop === 'tab2'" class="left-type_area sbar">
          <div class="device-search">
            <el-input
              placeholder="请输入搜索关键字"
              prefix-icon="el-icon-search"
              v-model="searchString"
              clearable
            >
            </el-input>
          </div>
          <el-scrollbar class="flex-auto" style="height: calc(100% - 50px)">
            <el-tree
              ref="tree"
              class="mb20"
              node-key="areaDevGroupCode"
              :default-expand-all="true"
              :data="areaTreeData"
              :highlight-current="true"
              :props="defaultProps"
              :filter-node-method="filterNode"
              @node-click="handleNodeClick"
            >
              <template slot-scope="{ node }">
                <element-tree-line
                  :node="node"
                  :showLabelLine="true"
                  :indent="16"
                  class="tree-line"
                >
                  <span class="custom-tree-node" style="display: block">
                    <i class="el-icon-document"></i>
                    <span style="margin-left: 3px">{{ node.label }}</span>
                  </span>
                </element-tree-line>
              </template>
            </el-tree>
          </el-scrollbar>
        </div>
      </div>
      <!-- 右侧表单 -->
      <div class="section-mian_right">
        <!-- 头部按钮 -->
        <div class="section-mian__toolbar flex-row">
          <el-button
            type="primary"
            class="iss-operation-button"
            icon="iconfont icon-iconfontfanhui"
            @click="retBtn"
            >{{ $t("cameraList.button.back") }}</el-button
          >
          <el-button
            type="primary"
            v-auth="'/cameralist/devicelist:move'"
            class="iss-operation-button"
            icon="iconfont icon-jinru"
            @click="moveIn"
            >{{ $t("cameraList.button.moveInto") }}</el-button
          >
          <el-button
            type="primary"
            size="small"
            class="iss-operation-button"
            :loading="downLoading"
            v-if="type.prop == 'tab1'"
            v-auth="'/cameralist/devicelist:export'"
            icon="iconfont icon-daochu"
            @click="fetchDownLoadFile"
          >
            {{ downLoading ? "导出中" : "导出" }}
          </el-button>
        </div>
        <!-- 搜索框部分 -->
        <!-- <div class="section-main__filter">
          <template v-if="devTypeSer">
            <el-checkbox
              v-model="searchForm.isDeviceWorkGroup"
              true-label="1"
              false-label=""
              @change="getDevList"
              >仅显示无设备组设备</el-checkbox
            >
          </template>
        </div> -->
        <!-- 右侧表格 -->
        <div class="section-main_table">
          <ioc-table
            ref="devTab"
            :data="tableData"
            :option="gasOption"
            @search-reset="emptyAreaData"
            @search-change="searchChange"
            :page="page"
            @current-change="selectPage"
            @selection-change="selectionChange"
            @size-change="changeSize"
          >
            <template slot="search_check">
              <template v-if="devTypeSer">
                <el-checkbox
                  true-label="1"
                  false-label=""
                  v-model="searchForm.isDeviceWorkGroup"
                  @change="getDevList"
                  >无设备组设备</el-checkbox
                >
              </template>
            </template>
            <!-- 定制操作栏按钮 -->
            <template slot="menu" slot-scope="scope">
              <el-tooltip
                class="item"
                effect="dark"
                v-if="type.prop === 'tab2'"
                :content="$t('cameraList.label.modify')"
                placement="top"
                popper-class="tooltip-draw"
              >
                <el-button
                  type="text"
                  icon="iconfont icon-xiugai"
                  @click="modDel(scope.row, scope.index)"
                ></el-button>
              </el-tooltip>
              <el-tooltip
                class="item"
                effect="dark"
                :content="$t('cameraList.label.viewDetail')"
                placement="top"
                popper-class="tooltip-draw"
              >
                <el-button
                  type="text"
                  class="el-icon-document"
                  @click="seeDel(scope.row)"
                ></el-button>
              </el-tooltip>
            </template>
          </ioc-table>
        </div>
      </div>
    </div>
    <!--选择设备树-->
    <el-dialog
      v-ops:width="380"
      width="30%"
      v-dialogDrag
      :title="type.prop === 'tab1' ? '选择挪入设备组' : '选择挪入区域'"
      :visible.sync="deviceTreeShow"
      center
    >
      <el-tree
        :data="gasDeviceTreeData"
        v-show="type.prop === 'tab1'"
        :highlight-current="true"
        :props="deviceDefaultProps"
        @node-click="selectDeviceNode"
      ></el-tree>
      <el-tree
        :data="areaTreeData"
        v-show="type.prop === 'tab2'"
        :highlight-current="true"
        :props="defaultProps"
        @node-click="selectAreaNode"
      ></el-tree>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="moveInDevice">{{
          $t("cameraList.button.conform")
        }}</el-button>
        <el-button @click="deviceTreeShow = false">{{
          $t("cameraList.button.cancel")
        }}</el-button>
      </span>
    </el-dialog>
    <!-- 修改设备数据弹框  -->
    <!-- <el-dialog
      title="设备编辑"
      :close-on-click-modal="false"
      v-dialogDrag
      :visible.sync="editDevDialog"
      width="750px"
      @opened="editDevDialogOpen"
    >
      <gasEditDev :gasDeviceInfo="gasDeviceInfo" ref="gasEditDev"></gasEditDev>
      <span slot="footer">
        <el-button @click="editDlgCan" :loading="subLoading">取 消</el-button>
        <el-button type="primary" @click="editDlgPre" :loading="subLoading">{{
          subLoading ? "提交中" : "确定"
        }}</el-button>
      </span>
    </el-dialog> -->

    <AppPanel
      class="app-panel"
      :width="700"
      :isExpand="editDevDialog"
      @cancel="editDevDialog = false"
      title="设备编辑"
    >
      <gasEditDev :gasDeviceInfo="gasDeviceInfo" ref="gasEditDev" style="padding-right: 20px;"></gasEditDev>
      <span slot="footer">
        <el-button @click="editDlgCan" :loading="subLoading">取 消</el-button>
        <el-button type="primary" @click="editDlgPre" :loading="subLoading">{{
          subLoading ? "提交中" : "确定"
        }}</el-button>
      </span>
    </AppPanel>
  </div>
</template>
<script>
import ElementTreeLine from "element-tree-line";
import { api } from "../api";
import gasEditDev from "../components/gasDeviceDialog.vue";
import utils from "@src/common/utils";
import { Dates } from "$utils";
import { gasTableOption } from "../const/gasTable";
import eleGroupTree from "../components/equipmentGroupTree";
import AppPanel from "@src/components/business/app-panel/index.vue";
import { Row } from "element-ui";
export default {
  components: {
    eleGroupTree,
    gasEditDev,
    ElementTreeLine,
    AppPanel
  },
  watch: {
    searchString(val) {
      this.$refs.tree.filter(val);
    }
  },
  data() {
    return {
      searchString: "",
      subLoading: false,
      editDevDialog: false,
      devInfoDialog: false,
      downLoading: false,
      clickSearch: false,
      selectedAreaNode: "",
      devTypeSer: true,
      //摄像机虚拟属性
      cameraFeature: "",
      deviceTreeShow: false,
      // 提示框内容
      tipData: "",
      // 选中的设备ID
      selDev: [],
      selThirdDev: [],
      selectedDevs: [],
      // 区域划分查询条件
      devAreaManu: "",
      devAreaName: "",
      // 控制仅显示无区域设备
      checked: false,
      type: {
        label: this.$t("cameraList.label.deviceSet"),
        prop: "tab1"
      },
      calType: {
        column: [
          {
            label: this.$t("cameraList.label.deviceSet"),
            prop: "tab1"
          },
          {
            label: this.$t("cameraList.label.areaSets"),
            prop: "tab2"
          }
        ]
      },
      // 区域树对象
      areaTreeData: [],
      // 设备组树对象
      gasDeviceTreeData: [],
      defaultProps: {
        children: "areaChildren",
        label: "areaDevGroupName"
      },
      deviceDefaultProps: {
        children: "children",
        label: "name",
        isLeaf: "isLeaf"
      },
      gasOption: gasTableOption(),
      tableData: [],
      // 分页属性设置
      page: {
        currentPage: 1,
        total: 0,
        pageSize: utils.Cache.get("CURRENT_PAGESIZE") || 10
      },
      selectedDeviceNode: "",
      // 左侧列表设备类型选中值
      deviceWorkGroupCode: "",
      searchForm: {
        deviceType: "",
        area: "", //区域id
        deviceWorkGroupCode: "", //设备组名称
        isDeviceWorkGroup: "" //显示无设备组设备
      },
      paramsType: "", //路由参数type,
      deviceInfo: {},
      gasDeviceInfo: {},
      isIndoorList: [
        {
          label: "是",
          value: 1
        },
        {
          label: "否",
          value: 0
        }
      ]
    };
  },
  created() {
    this.deviceInfo = JSON.parse(this.$route.query.device);
    this.paramsType = this.deviceInfo.deviceType;
    this.initGet();
    this.getAreaTree();
    this.type = this.calType.column[0];
  },
  methods: {
    filterNode(value, data) {
      if (!value) {
        return true;
      }
      return data.areaDevGroupName.indexOf(value) !== -1;
    },
    editDlgPre() {
      let data = this.$refs.gasEditDev.deviceForm;
      console.info("222222222====", data)
      let params = {
        buildingCode: data.buildingCode,
        abscissa: data.abscissa,
        ordinate: data.ordinate,
        width: data.width,
        height: data.height,
        deviceId: data.deviceId,
        deviceName:
          data.deviceMark == 34 ? data.deviceName : data.parentDeviceName,
        latitude: data.latitude,
        longitude: data.longitude,
        isIndoor: data.isIndoor,
        deviceDescription:
          data.deviceMark == 34
            ? data.deviceDescription
            : data.parentDeviceDescription,
        area: data.area,
        buildingId: data.buildingId,
        buildName: data.buildName
      };
      this.subLoading = true;
      this.$fetch(api.deviceMan.updateDeviceInfoById, params).then((res) => {
        this.subLoading = false;
        if (res.success === true) {
          this.$message.success(res.msgContent);
          this.editDevDialog = false;
          this.getDevList();
        } else if (res.success === false) {
          this.$message.error(res.msgContent);
        }
      });
    },
    // 编辑框取消按钮
    editDlgCan() {
      this.editDevDialog = false;
    },
    editDevDialogOpen() {},
    // 条件查询
    searchChange(params) {
      if (JSON.stringify(params) == "{}") {
        let searchForm = {
          deviceType: this.deviceInfo.deviceTypeId,
          area: this.searchForm.area, //区域id
          deviceWorkGroupCode: this.searchForm.deviceWorkGroupCode, //设备组名称
          isDeviceWorkGroup: this.searchForm.isDeviceWorkGroup //显示
        };
        this.searchForm = Object.assign({}, searchForm);
      } else {
        this.searchForm.deviceName = params.parentDeviceName || "";
        this.searchForm.thirdDeviceId = params.parentThirdDeviceId || "";
      }
      this.getDevList();
    },
    // 导出下载
    fetchDownLoadFile() {
      this.downLoading = true;
      this.$fetchDownLoad(api.deviceMan.getDeviceExportList, this.searchForm, {
        responseType: "arraybuffer"
      }).then((response) => {
        this.downLoading = false;
        const content = response.data;
        const blob = new Blob([content], { type: "application/vnd.ms-excel" });
        const fileName =
          "消防设备信息" +
          Dates.format(Date.now(), "yyyyMMddHHmmssms") +
          ".xlsx";
        if ("download" in document.createElement("a")) {
          // 非IE下载
          const elink = document.createElement("a");
          elink.download = fileName;
          elink.style.display = "none";
          elink.href = URL.createObjectURL(blob);
          document.body.appendChild(elink);
          elink.click();
          URL.revokeObjectURL(elink.href); // 释放URL 对象
          document.body.removeChild(elink);
        } else {
          // IE10+下载
          navigator.msSaveBlob(blob, fileName);
        }
      });
    },
    //挪入
    moveIn() {
      if (this.selDev.length <= 0) {
        this.$message({
          message: this.$t("cameraList.message.chooseEnter"),
          type: "warning"
        });
        return;
      }
      this.deviceTreeShow = true;
      this.getAreaTree();
    },
    emptyAreaData(){
      this.searchForm.deviceName = "";
      this.searchForm.thirdDeviceId = "";
      this.page.currentPage = 1;
      this.getDevList();
    },
    // 请求设备列表
    getDevList() {
      this.tableData = [];
      const params = Object.assign(this.searchForm, {
        page: this.page.currentPage,
        pageSize: this.page.pageSize
      });
      const loading = this.$loading({
        lock: true,
        text: "请求中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      this.$fetch(api.deviceMan.getDeviceListByPage, params).then((res) => {
        setTimeout(() => {
          loading.close();
        }, 500);
        if (res.success) {
          this.$refs.devTab.selectClear();
          this.tableData = res.returnObj.list;
          this.page.total = res.returnObj.total;
        } else {
          this.$message({
            message: res.msgContent,
            type: "error"
          });
        }
      });
    },
    // 获取设备tree
    getAreaTree() {
      this.$fetch(api.deviceMan.queryAssociationalDeviceTree).then((res) => {
        this.areaTreeData = res.returnObj;
        this.$nextTick(() => {
          this.$refs.tree.setCurrentKey(this.areaTreeData[0]);
        });
      });
    },
    // tree检索回调
    getGasTreeData(data) {
      this.gasDeviceTreeData = data;
    },
    // 查看详情按钮
    seeDel(row) {
      this.$refs.devTab.rowView(row);
    },
    // 修改设备详情
    modDel(row) {
      this.editDevDialog = true;
      this.gasDeviceInfo = JSON.parse(JSON.stringify(row));
    },
    // 挪入确定btn
    moveInDevice() {
      if (this.type.prop === "tab1") {
        if (this.selectedDeviceNode === "") {
          this.$message.warning("请选择挪入的设备组");
          return;
        }
        let params = {
          operateType: 1,
          deviceWorkGroupCode: this.selectedDeviceNode,
          deviceIdList: this.selDev
        };
        this.$fetch(api.updateDeviceDeviceWorkGroup, params).then(
          (response) => {
            if (response.success) {
              this.$message({
                message: this.$t("cameraList.message.moveIntoSucc"),
                type: "success"
              });
              this.deviceTreeShow = false;
              // 刷新界面数据
              this.getDevList();
              this.$refs.devTab.selectClear();
            } else {
              this.$message({
                message: response.msgContent,
                type: "warning"
              });
            }
          }
        );
      } else {
        if (this.selectedAreaNode === "") {
          this.$message.warning(this.$t("cameraList.message.chooseEnterArea"));
          return;
        }
        let params = {
          area: this.selectedAreaNode,
          deviceIds: this.selDev
        };
        this.$fetch(api.deviceMan.updateDeviceArea, params).then((response) => {
          if (response.success) {
            this.$message({
              message: this.$t("cameraList.message.moveIntoSucc"),
              type: "success"
            });
            this.deviceTreeShow = false;
            // 刷新界面数据
            this.getDevList();
            this.$refs.devTab.selectClear();
          } else {
            this.$message({
              message: response.msgContent,
              type: "warning"
            });
          }
        });
      }
    },
    // 挪入选中设备组
    selectAreaNode(data) {
      this.selectedAreaNode = data.areaDevGroupCode;
    },
    selectDeviceNode(data) {
      this.selectedDeviceNode = data.id;
    },
    // 树节点点击事件
    handleNodeClick(data) {
      this.searchForm.deviceWorkGroupCode = "";
      this.searchForm.area = data.areaDevGroupCode;
      this.page.currentPage = 1;
      this.getDevList();
    },

    // 分页事件
    selectPage(val) {
      this.$refs.devTab.selectClear();
      this.page.currentPage = val;
      this.getDevList();
    },
    changeSize(val) {
      this.page.pageSize = val;
      this.page.currentPage = 1;
      this.getDevList();
    },
    // 切换左侧选项卡
    handleChange(column) {
      this.type = column;
      this.page.currentPage = 1;
      this.page.pageSize = 10;
      let searchForm = {
        deviceType: this.deviceInfo.deviceTypeId,
        area: "", //区域id
        deviceWorkGroupCode: "", //设备组名称
        isDeviceWorkGroup: "" //显示
      };
      if (this.type.prop === "tab1") {
        this.devTypeSer = true;
        this.gasOption.column[2].hide = false;
        this.gasOption.column[2].viewDisplay = true;
        this.gasOption.column[3].hide = true;
        this.gasOption.column[3].viewDisplay = false;
        this.gasOption.column[4].viewDisplay = false;
      } else {
        this.devTypeSer = false;
        this.gasOption.column[2].hide = true;
        this.gasOption.column[2].viewDisplay = false;
        this.gasOption.column[3].hide = false;
        this.gasOption.column[3].viewDisplay = true;
        this.gasOption.column[4].viewDisplay = true;
      }
      this.searchForm = Object.assign({}, searchForm);
      this.getDevList();
    },
    // 初始化查询条件，查询全量数据；
    initGet() {
      let searchForm = {
        deviceType: this.deviceInfo.deviceTypeId,
        area: "", //区域id
        deviceWorkGroupCode: "", //设备组名称
        isDeviceWorkGroup: "" //显示
      };
      this.searchForm = Object.assign({}, searchForm);
      this.getDevList();
    },
    // 勾选事件
    selectionChange(selections) {
      if (selections.length < this.page.pageSize && selections.length > 0) {
        setTimeout(() => {
          $(".el-table__fixed-header-wrapper label.el-checkbox>span").attr(
            "class",
            "el-checkbox__input is-indeterminate"
          );
        }, 200);
      }
      this.selDev = [];
      this.selThirdDev = [];
      this.selectedDevs = selections;
      selections.map((item) => {
        this.selDev.push(item.deviceId);
        this.selThirdDev.push(item.thirdDeviceId);
      });
    },
    retBtn() {
      this.$router.push({
        path: "/cameralist/devicelist",
        name: "devicelist"
      });
    },
    // 点击设置组
    handleClickDeviceGroup(code) {
      this.searchForm.deviceWorkGroupCode = code;
      this.searchForm.area = "";
      this.page.currentPage = 1;
      this.getDevList();
    }
  }
};
</script>
<style lang="scss">
@import "~@src/common/assets/style/mixin";
.gas-page {
  width: 100%;
  height: 100%;
  .left_title {
    border-left: 4px solid #407aee;
    padding-left: 8px;
    margin: 16px;
  }
  .device-tab {
    display: flex;
    margin: 0 16px 0px 16px;
    .tab {
      color: #9aa6c1;
      flex: 1;
      text-align: center;
      padding-bottom: 10px;
      border-bottom: 1px solid #707070;
      &:hover {
        color: #fff;
        cursor: pointer;
      }
    }
    .active {
      color: #fff;
      border-color: #407aee;
    }
  }
  .device-search {
    display: flex;
    margin: 15px 16px;
    height: 28px;
    .el-input {
      width: 100%;
    }
  }
  .left-type_area {
    height: calc(100% - 100px);
    position: relative;
    flex: 1;
    overflow: hidden;
    @include set_theme_color(background-color, left-menu-bg-color);
  }
  .upload-demo {
    margin: 0 10px;
  }

  .el-tabs--bottom .el-tabs__item.is-bottom:nth-child(2),
  .el-tabs--bottom .el-tabs__item.is-top:nth-child(2),
  .el-tabs--top .el-tabs__item.is-bottom:nth-child(2),
  .el-tabs--top .el-tabs__item.is-top:nth-child(2) {
    padding-left: 10px;
  }
}
.el-select {
  width: 100%;
}
</style>
